module.exports = __webpack_public_path__ + "img_balao.png?9285fa565acd07eeaaa9eccfa123acb4";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img_balao.png
// module id = 10
// module chunks = 0